// External libraries
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';

// Internal modules
import { features } from '@/lib';
import { OnboardTerms } from '../../OnboardTerms';
import { MarketingOptIn } from './MarketingOptIn';
import { DisclosuresContainer } from './styledComponents';
import { LazySepaMandate } from './Components';
import { BillingTerms } from '../../BillingTerms';

const LegalDisclosures = props => {
  const fiType = useStoreState(({ ui }) => ui.fiType);
  const billingType = features.get('billingType');
  //uses same determination logic for now but will not in the future
  const isBillingAgreement = !!billingType;

  return (
    <DisclosuresContainer>
      {features.isActive('hasMarketingOptInCheckbox') && (
        <MarketingOptIn changeHandler={props.changeHandler} />
      )}

      <OnboardTerms changeHandler={props.changeHandler} type="signup" />

      {features.isActive('hasSepaMandate') && fiType === 'bank' && (
        <LazySepaMandate changeHandler={props.changeHandler} />
      )}

      {isBillingAgreement && <BillingTerms type={billingType} />}
    </DisclosuresContainer>
  );
};

LegalDisclosures.propTypes = {
  changeHandler: func,
};

export { LegalDisclosures };
